// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueTheMask from 'vue-the-mask'
import VeeValidate, { Validator } from 'vee-validate'
import ptBr from 'vee-validate/dist/locale/pt_BR'
import store from './store/'
import BaseInput from './components/base/BaseInput'
import BaseButton from './components/base/BaseButton'
import money from 'v-money'
import VueNumeric from 'vue-numeric'
import FileUpload from 'v-file-upload'
import VueWait from 'vue-wait'
import { Auth0Plugin } from "./auth";
import VueMeta from 'vue-meta';

Vue.config.productionTip = false;
Vue.use(VueMeta)
Vue.use(VueWait)
Vue.use(FileUpload)
Validator.localize('pt_BR', ptBr)
Vue.use(VueTheMask)
Vue.use(money)
Vue.use(VueNumeric)
Vue.use(VeeValidate, { inject: false, fieldsBagName: 'veeFields', locale: ptBr })
Vue.component(BaseInput.name, BaseInput)
Vue.component(BaseButton.name, BaseButton)
Vue.use(BootstrapVue)

let domain = process.env.VUE_APP_AUTH_DOMAIN;
let audience = process.env.VUE_APP_AUTH_AUDIENCE;
let clientId = process.env.VUE_APP_AUTH_CLIENTID;

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  wait: new VueWait({
    // Defaults values are following:
    useVuex: false,              // Uses Vuex to manage wait state
    vuexModuleName: 'wait',      // Vuex module name

    registerComponent: true,     // Registers `v-wait` component
    componentName: 'v-wait',     // <v-wait> component name, you can set `my-loader` etc.

    registerDirective: true,     // Registers `v-wait` directive
    directiveName: 'wait',       // <span v-wait /> directive name, you can set `my-loader` etc.

  }),
  template: '<App/>',
  components: {
    App
  }
})
